interface Props {
  placeholder?: string;
  onSearch: any;
  value: any;
  onChange: any;
}

export const AdminSearchBar = ({
  placeholder,
  onSearch,
  value,
  onChange,
}: Props) => {
  return (
    <section className='flex-1 flex justify-between max-w-7xl mx-auto text-gray-400 focus-within:text-gray-600'>
      <form
        className='w-full flex justify-center md:ml-0 focus-within:bg-gray-100 px-4'
        action='#'
        method='GET'>
        <label htmlFor='search_field' className='sr-only'>
          Search
        </label>

        {/* <!-- Heroicon name: search --> */}
        <svg
          aria-hidden='true'
          className='flex-shrink-0 h-5 w-5 pointer-events-none my-auto'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 20 20'
          fill='currentColor'>
          <path
            fillRule='evenodd'
            d='M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z'
            clipRule='evenodd'
          />
        </svg>

        <input
          name='search_field'
          id='search_field'
          className='h-full w-full border-transparent py-2 pl-8 pr-3 text-sm text-gray-900 placeholder-gray-500 border-none focus:outline-none focus:ring-0 focus:border-transparent focus:placeholder-gray-400 focus:bg-gray-100'
          placeholder={placeholder || 'Search'}
          type='search'
          value={value}
          onChange={onChange}
        />
        <button
          type='submit'
          className='hover:text-gray-900'
          onClick={(e) => {
            e.preventDefault();
            onSearch();
          }}>
          Search
        </button>
      </form>
    </section>
  );
};
